export default __webpack_public_path__ + "static/media/Golf-Simulator.b786e7fb.webp";